import React, { useState } from "react";
import { Client, Databases, ID } from "appwrite";
import colorlogo from "../assets/Academy/colorlogo.png";
import close from "../assets/Academy/close.webp";
import CalendlyEmbed from "../pages/CalendlyEmbed";
import config from "../config/config";
const BookaCall = ({ isOpen, onClose }) => {
  const [selectedInterest, setSelectedInterest] = useState("");
  const [showCalendly, setShowCalendly] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [documentId, setDocumentId] = useState(""); // Store the document ID
  
  // Appwrite client setup
  const client = new Client()
    .setEndpoint(process.env.REACT_APP_ENDPOINT)
    .setProject(process.env.REACT_APP_PROJECT_ID);

  const databases = new Databases(client);

  if (!isOpen) return null;
  
  const handleNextClick = async () => {
    if (!selectedInterest) {
      alert("Please select an interest option");
      return;
    }
    
    setIsLoading(true);
    
    try {
      // Save the selected interest to Appwrite
      const response = await databases.createDocument(
        process.env.REACT_APP_DATABASE_ID,
        config.collectionIds.academyBookACall,
        ID.unique(),
        {
          interestType: selectedInterest,
        }
      );
      

      setDocumentId(response.$id);
      
      
      setShowCalendly(true);
    } catch (error) {
      console.error("Error saving interest data:", error);
      alert("Failed to save your selection. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  if (showCalendly) {
    return (
      <CalendlyEmbed
        isOpen={true}
        onClose={() => {
          setShowCalendly(false);
          onClose();
        }}
        selectedInterest={selectedInterest}
        documentId={documentId} // Pass the document ID to CalendlyEmbed
      />
    );
  }

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
      <div className="bg-white rounded-lg shadow-lg w-11/12 md:w-full md:max-w-4xl p-6 relative flex flex-col md:flex-row">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-600 hover:text-gray-900"
        >
          <img src={close} alt="Close" className="w-3 h-3" />
        </button>
        <div className="w-full md:w-1/2 flex flex-col justify-center items-center text-center md:border-r border-gray-300 md:py-10 md:pr-20 md:pl-6">
          <img src={colorlogo} alt="Logo" className="w-63 mb-4" />
          <h2 className="text-xl text-left font-bold text-[rgba(62,89,183,1)]">
            Book a call with our team today!
          </h2>
          <p className="text-gray-700 text-sm text-left mt-2">
            Book a call with one of our team members to help provide you
            information on enterprise solutions.
          </p>
        </div>
        <div className="w-full md:w-1/2 md:pl-6 md:p-10">
          <h2 className="text-md font-semibold mb-8">
            Please select the appropriate option that best describes your
            interest in our courses?
          </h2>
          <div className="space-y-8 w-full">
            <div className="flex items-center w-full flex-nowrap">
              <input
                type="radio"
                name="interest"
                className="accent-[rgba(62,89,183,1)] scale-90 mr-2 md:mr-6"
                checked={selectedInterest === "individual"}
                onChange={() => setSelectedInterest("individual")}
              />
              <span className="text-[rgba(0,0,0,1)] text-sm md:text-base mr-44 text-nowrap">
                Individual booking
              </span>
            </div>
            <div className="flex items-center w-full flex-nowrap">
              <input
                type="radio"
                name="interest"
                className="accent-[rgba(62,89,183,1)] scale-90 mr-2 md:mr-6"
                checked={selectedInterest === "small-business"}
                onChange={() => setSelectedInterest("small-business")}
              />
              <span className="text-[rgba(0,0,0,1)] text-sm md:text-base mr-44 text-nowrap">
                Small Business (2-20 Employees)
              </span>
            </div>
            <div className="flex items-center w-full flex-nowrap">
              <input
                type="radio"
                name="interest"
                className="accent-[rgba(62,89,183,1)] scale-90 mr-2 md:mr-6"
                checked={selectedInterest === "medium-business"}
                onChange={() => setSelectedInterest("medium-business")}
              />
              <span className="text-[rgba(0,0,0,1)] text-sm md:text-base mr-44 text-nowrap">
                Medium Business (21-200 Employees)
              </span>
            </div>
            <div className="flex items-center w-full flex-nowrap">
              <input
                type="radio"
                name="interest"
                className="accent-[rgba(62,89,183,1)] scale-90 mr-2 md:mr-6"
                checked={selectedInterest === "large-business"}
                onChange={() => setSelectedInterest("large-business")}
              />
              <span className="text-[rgba(0,0,0,1)] text-sm md:text-base mr-44 text-nowrap">
                Large Business (201+ Employees)
              </span>
            </div>
          </div>
          <button
            onClick={handleNextClick}
            className={`mt-6 w-full bg-[rgba(62,89,183,1)] text-white py-2 rounded-lg hover:bg-blue-700 ${
              isLoading ? "opacity-50 cursor-not-allowed" : ""
            }`}
            disabled={isLoading}
          >
            {isLoading ? "Processing..." : "Next"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default BookaCall;